import { useCallback } from "react";
import { Button, Stack, Typography } from "@mui/material";
import { useSearchParams } from "react-router-dom";
import { useFlag } from "@unleash/proxy-client-react";
import { DropdownFooterComponent } from "@/components/common/select/dropdown-select/utils/types/types";
import { useAppDispatch } from "@/store/hooks";
import { setBillingExplorerSideBarPanelContentType } from "@/store/resource-explorer/resourceExplorerSlice";
import { collapseCostAllocationTagsSearchParam } from "@/components/pages/resource-explorer/components/settings-panel/components/tags-settings-section/VewTagsSelect";
import { useFilterTreeContext } from "@/components/pages/common/filters-tree/filters-selection/components/FilterTreeProvider";

export const TagFilterKeyDropdownFooter: DropdownFooterComponent = ({
  onClose,
}) => {
  const dispatch = useAppDispatch();
  const { onParentClose } = useFilterTreeContext();
  const [searchParams, setSearchParams] = useSearchParams();

  const enableCustomTagsEnablementForAWS = useFlag(
    "EnableCustomTagsEnablementForAWS",
  );

  const billingExplorerSettingsPanelOpenHandler = useCallback(() => {
    onClose();
    onParentClose?.();
    dispatch(
      setBillingExplorerSideBarPanelContentType("billingExplorerSettings"),
    );

    searchParams.set(collapseCostAllocationTagsSearchParam, "true");
    setSearchParams(searchParams);
  }, [dispatch, setSearchParams, onParentClose, searchParams, onClose]);

  if (!enableCustomTagsEnablementForAWS) {
    return null;
  }

  return (
    <Stack p={1.5} justifyContent="center">
      <Button size="small" onClick={billingExplorerSettingsPanelOpenHandler}>
        Manage Tags List
      </Button>

      <Typography variant="caption" color="text.disabled" align="center">
        If you can’t find your preferred tags, you need <br />
        to enable them first.
      </Typography>
    </Stack>
  );
};
